/**
 * Configuração centralizada de branding do software.
 * Cores e paths de assets.
 */

export const branding = {
  /** Cores da marca (Pantone) */
  colors: {
    orange: '#cb532e',    // Pantone Orange 021C
    red: '#9b242a',       // Pantone 7621C
    gray: '#636362',      // Pantone Cool Gray 10C
  },
  /** Paths dos assets (public/branding/) */
  assets: {
    imageLogin: '/branding/image-login.jpg',
    imageLandingPage: '/branding/image-landing-page.jpg',
    logo: '/branding/engeview_logo.svg',
    logoPng: '/branding/engeview_logo.png',
    icon: '/branding/engeview_coruja.svg',
    iconPng: '/branding/engeview_logo.png',
    /** Logo Engeview no login. SVG = nítido em qualquer tamanho (exportar do .ai); PNG = use alta resolução (ex.: 320px altura) */
    logoEngeviewSvg: '/branding/engeview_logo.svg',
    logoEngeviewPng: '/branding/engeview_logo.png',
    favicon: '/branding/favicon.svg',
    faviconIco: '/branding/favicon.ico',
    appleTouchIcon: '/branding/apple-touch-icon.png',
  },
  /** Nome exibido na logo */
  appName: 'Engeview Gestão de Projetos',
} as const;
